// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"282":"d4bac654","323":"580e2634","535":"ad7c0a5d","549":"c7794cff","551":"36cca698","632":"a45fbd8d","641":"cce4f28b","751":"2a53a765","770":"2f747235","820":"7384d461","841":"5cc62456"}[chunkId] + ".chunk.js";
};